(function () {
	'use strict';

	angular.module('mx.SolutionBuilderAgent').component('mxPropertyBindingMapper', {
		bindings: {
			value: '=?',
			label: '@',
			disabled: '=ngDisabled',
		},
		controller: MxPropertyBindingMapperCtrl,
		controllerAs: 'vm',
		templateUrl: 'workspaces/SolutionBuilderAgent/components/mx-property-binding-mapper/mx-property-binding-mapper.html',
	});

	MxPropertyBindingMapperCtrl.$inject = ['$scope', '$timeout'];

	function MxPropertyBindingMapperCtrl($scope, $timeout) {
		var vm = this;
		var localChanged;

		vm.$onInit = function () {
			vm.propertyName = '';
			localChanged = false;

			vm.mappingTypes = [
				{
					name: 'None',
					value: -1,
					showMappingName: false,
					showPropertyName: false,
					showMappingValueType: false,
				},
				{
					name: 'Attribute',
					value: 0,
					showMappingName: true,
					showPropertyName: true,
					showMappingValueType: false,
				},
				{
					name: 'Child',
					value: 1,
					showMappingName: true,
					showPropertyName: true,
					showMappingValueType: true,
				},
				{
					name: 'Self',
					value: 2,
					showMappingName: false,
					showPropertyName: true,
					showMappingValueType: true,
				},
				{
					name: 'Parent',
					value: 3,
					showMappingName: false,
					showPropertyName: true,
					showMappingValueType: true,
				},
			];

			vm.mappingValueTypes = [
				{
					name: 'By Editor Type',
					value: 0,
				},
				{
					name: 'Object Name',
					value: 1,
				},
				{
					name: 'Object',
					value: 2,
				},
			];

			vm.mappingTypes.getCurrentItem = function () {
				return (
					_.find(vm.mappingTypes, function (obj) {
						return obj.value === vm.mappingType;
					}) || {}
				);
			};

			vm.mappingTypes.showMappingName = function () {
				return vm.mappingTypes.getCurrentItem().showMappingName;
			};

			vm.mappingTypes.showMappingValueType = function () {
				return vm.mappingTypes.getCurrentItem().showMappingValueType;
			};

			vm.mappingTypes.showPropertyName = function () {
				return vm.mappingTypes.getCurrentItem().showPropertyName;
			};
		};

		$scope.$watch('vm.value', function (newValue) {
			if (localChanged) {
				localChanged = false;
			} else {
				vm._value = newValue ? JSON.parse(newValue) : { MappingType: -1 };
				vm.mappingType = vm._value.MappingType;
				vm.mappingValueType = vm._value.MappingValueType || 0;
				vm.mappingName = vm._value.MappingName;
			}
		});

		$scope.$watch(
			'vm._value',
			function (newValue) {
				localChanged = true;
				processValue(newValue);
			},
			true
		);

		$scope.$watch('vm.mappingType', function (newValue, oldValue) {
			if (newValue === oldValue) {
				return;
			}
			vm._value.MappingType = newValue;
		});

		$scope.$watch('vm.mappingValueType', function (newValue, oldValue) {
			if (newValue === oldValue) {
				return;
			}
			vm._value.MappingValueType = newValue;
		});

		vm.propertyNameUpdate = function () {
			vm._value.PropertyName = vm.propertyName ? vm.propertyName : undefined;
		};

		vm.mappingNameUpdate = function () {
			vm._value.MappingName = vm.mappingName ? vm.mappingName : undefined;
		};

		function processValue(value) {
			$timeout(function () {
				if (value.PropertyName) {
					vm.propertyName = value.PropertyName;
				}

				if (value.MappingValueType !== undefined) {
					vm.mappingValueType = value.MappingValueType;
				}

				if (value.MappingName) {
					vm.mappingName = value.MappingName;
				}

				processType(value);

				var obj = angular.copy(value);

				if (obj.MappingType === -1) {
					vm.value = undefined;
					return;
				}

				obj.PropertyName = obj.PropertyName || undefined;
				vm.value = JSON.stringify(obj);
			});
		}

		function processType(value) {
			var item = vm.mappingTypes.getCurrentItem();

			if (item.showMappingValueType) {
				value.MappingValueType = vm.mappingValueType;
			} else {
				value.MappingValueType = undefined;
			}

			if (item.showMappingName) {
				value.MappingName = vm.mappingName;
			} else {
				value.MappingName = undefined;
			}
		}
	}
})();
